import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { getSampleData, saveSampleData, setSampleData, triggerSampleData } from '../actions/sampleData.actions';

@Injectable()
export class SampleDataEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  getSampleData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getSampleData),
        map((action) => {
          if (!action.apiConstants) {
            return;
          }
          return this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((result: any) => {
            this.store.dispatch(
              setSampleData({
                sampleDataTable: result
              })
            );
          });
        })
      ),
    { dispatch: false }
  );

  triggerSampleData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(triggerSampleData),
        map((action) => {
          if (!action.apiConstants) {
            return;
          }
          return this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((result: any) => {
            this.store.dispatch(
              getSampleData({
                apiConstants: ApiConstants.getPrototypeSampleData
              })
            );
          });
        })
      ),
    { dispatch: false }
  );

  saveSampleData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveSampleData),
        map((action) => {
          if (!action.saveapiConstants) {
            return;
          }
          return this.baseService[action.saveapiConstants?.method](
            action.saveapiConstants,
            action.sampleData
          ).subscribe((result: any) => {
            console.log(result);
          });
        })
      ),
    { dispatch: false }
  );
}
